import { Empresas } from "../../models/Empresas";
import { GenericComponent } from "../../components/GenericComponent";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { EmpresaService } from "../../service/EmpresaService";
import { InputComponent } from "../../components/InputComponent";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { MenuFuncion } from "./MenuFuncion";
import { Parametrizacion } from "./Parametrizacion";
import { ConfiguracionEmpresa } from "./ConfiguracionEmpresa";
import { useToken } from "../../components/useToken";
import { FormActionButtons } from "../../components/ui/FormActionButtons";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Menu } from "primereact/menu";

export const Empresa = () => {

    const generic = new GenericComponent();
    const omodel = new Empresas();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const empresaService = new EmpresaService();
    const [empresa, setEmpresa] = useState(null);
    const toast = useRef(null);
    const menuRef = useRef(null);
    const { getRol } = useToken();
    const [dialogEmpresa, setDialogEmpresa] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [fileSize, setFileSize] = useState(0);
    const [opcion, setOpcion] = useState(null);
    const [dialogConfig, setDialogConfig] = useState(false);
    const [dialogEtiqueta, setDialogEtiqueta] = useState(false);
    const [load, setLoad] = useState(false);
    const [dialogConfigEmpresa, setdialogConfigEmpresa] = useState(false);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { inDrop, inDropMultiple, inText, inFile, inSwitch } = InputComponent({ omodel, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        empresaService.getEmpresa({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setCatalogos(res.data.catalogos);
                setOpcion(res.data.opcion);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        setDialogEmpresa(true);
        setEmpresa(null);
        reset(defaultValues);
    }

    const buildFormData = (data) => {
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            const value = data[key];
            if (value === null || value === undefined) return;
            if (key === 'logo' && value instanceof File) formData.append(key, value); // Append the File object directly
            else formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
        });
        return formData;
    }

    const onSubmit = (data) => {
        setLoad(true);
        const enviarData = data.logo != null ? buildFormData(data) : data;
        const request = getValues('id') == null ? empresaService.newEmpresa(enviarData) : empresaService.editarEmpresa(enviarData);
        request.then(res => {
            generic.funcSuccess(res, toast);
            setDialogEmpresa(false);
            loadLazyData();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const editEmpresa = () => {
        empresaService.consultarEmpresa(empresa?.id, 0).then(res => {
            const cats = catalogos;
            const _empresa = res.data.empresa;
            setEsRuc(JSON.stringify(_empresa.tipo_identificacion) === JSON.stringify(cats.ruc));
            setEsCedula(JSON.stringify(_empresa.tipo_identificacion) === JSON.stringify(cats.cedula));
            reset(generic.renewValues(_empresa, omodel.model));
            setDialogEmpresa(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la empresa?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarEmpresa()
        });
    }

    const eliminarEmpresa = () => {
        empresaService.eliminarEmpresa(empresa?.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onChangeTipo = (e) => {
        setEsRuc(JSON.stringify(e.value) === JSON.stringify(catalogos.ruc));
        setEsCedula(JSON.stringify(e.value) === JSON.stringify(catalogos.cedula));
    }

    const siOpcion = (permiso, strOpcion) => {
        return permiso && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editEmpresa() } });
        if (siOpcion(permss?.actualizar, 'empresa-etiqueta'))
            items.push({ label: 'Menús - asignar etiquetas', icon: 'pi pi-gauge', command: () => { setDialogEtiqueta(true) } });
        if (siOpcion(permss?.actualizar, 'empresa-configuracion'))
            items.push({ label: 'Configuración', icon: 'pi pi-address-book', command: () => { setdialogConfigEmpresa(true) } });
        if (siOpcion(permss?.actualizar, 'empresa-parametro'))
            items.push({ label: 'Parámetros', icon: 'pi pi-th-large', command: () => { setDialogConfig(true) } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-th-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const siEdicion = (opcion = null) => {
        const res = opcion ? generic.infoIdentificacion(opcion) : {};
        res.readOnly = empresa?.fecha;
        return res;
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const cerrarModal = () => {
        setDialogEmpresa(false);
        setFileSize(0);
    }

    const footerModal = (
        <FormActionButtons formId="form-empresa" onCancel={cerrarModal} isSaving={load} className="pt-2" />
    );

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup onClick={(event) => { setEmpresa(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nueva empresa', permss)}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>

            <Dialog visible={dialogEmpresa} header={getValues('id') == null ? "Nueva empresa" : "Editar empresa"} modal
                className="p-fluid modal-ssize dialog-personalizado" onHide={cerrarModal} style={{ maxWidth: '850px' }} footer={footerModal}>
                <form id="form-empresa" onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inDrop('tipo_identificacion', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTipo }, 6)}
                        {esCedula && inText('identificacion', siEdicion('cedula'), 6)}
                        {!esCedula && !esRuc && inText('identificacion', {}, 6)}
                        {esRuc && inText('identificacion', siEdicion('ruc'), 6)}
                        {inText('razon_social', siEdicion(), 6)}
                        {inText('nombre_comercial', siEdicion(), 6)}
                        {inDrop('tipo_empresa', catalogos?.tipo_empresa, { lab: omodel.optionLabel }, 6)}
                        {inDrop('grupo', catalogos?.grupo, { lab: omodel.optionLabel }, 6)}
                        {inDrop('formulario_empresa', catalogos?.formularioEmpresa, { lab: omodel.optionLabel }, 6)}
                        {inDropMultiple('tipo_negocio', catalogos?.negocio, { lab: omodel.optionLabel }, 6)}

                        <div className="col-12 my-3">
                            <div className="surface-card p-3 shadow-1 border-round border-1 surface-border">
                                <div className="flex align-items-center mb-3">
                                    <i className="pi pi-sliders-h text-primary mr-2 text-base"></i>
                                    <span className="font-semibold text-700 text-sm">Configuraciones y Estados</span>
                                </div>
                                <div className="grid">
                                    {inSwitch('estado', { labelTrue: 'ACTIVO', labelFalse: 'INACTIVO', tooltip: 'Estado operativo de la empresa' }, 4)}
                                    {inSwitch('matriz_formulario', { labelTrue: 'SI', labelFalse: 'NO', tooltip: '¿Habilitar formulario a matriz?' }, 4)}
                                    {inSwitch('notifica_recepcion', { labelTrue: 'SI', labelFalse: 'NO', tooltip: 'Enviar correo de notificación al recibir el formulario del cliente' }, 4)}
                                </div>
                            </div>
                        </div>
                        {inFile('logo', { fileSize, setFileSize, obl: false, ml: ' col-12' })}
                    </div>
                </form>
            </Dialog>

            <Dialog visible={dialogEtiqueta} header={"Asignar etiquetas: " + empresa?.razon_social} modal className="p-fluid modal-ssize" onHide={e => setDialogEtiqueta(false)}
                style={{ maxWidth: '900px' }}>
                {<MenuFuncion empresa={empresa?.id} toast={toast} generic={generic} permss={permss} opcion="empresa" lista={catalogos?.negocio} />}
            </Dialog>

            <Dialog visible={dialogConfig} header={"Parámetros empresa: " + empresa?.razon_social} modal className="p-fluid modal-ssize" onHide={e => setDialogConfig(false)}
                style={{ maxWidth: '900px' }}>
                {<Parametrizacion id={empresa?.id} toast={toast} generic={generic} permss={permss} opcion="empresa" />}
            </Dialog>

            <Dialog visible={dialogConfigEmpresa} header={"Configuración empresa: " + empresa?.razon_social} modal className="p-fluid modal-ssize" onHide={e => setdialogConfigEmpresa(false)}
                style={{ maxWidth: '900px' }}>
                {<ConfiguracionEmpresa id={empresa?.id} toast={toast} generic={generic} permss={permss} setDialog={setdialogConfigEmpresa} />}
            </Dialog>
        </>
    )
}
